var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDigitalItemColored(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7008_1169",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7008_1169)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 7.33333V2H7.33333V7.33333H2ZM3.33333 6H6V3.33333H3.33333V6ZM2 14V8.66667H7.33333V14H2ZM3.33333 12.6667H6V10H3.33333V12.6667ZM8.66667 7.33333V2H14V7.33333H8.66667ZM10 6H12.6667V3.33333H10V6ZM12.6667 14V12.6667H14V14H12.6667ZM8.66667 10V8.66667H10V10H8.66667ZM10 11.3333V10H11.3333V11.3333H10ZM8.66667 12.6667V11.3333H10V12.6667H8.66667ZM10 14V12.6667H11.3333V14H10ZM11.3333 12.6667V11.3333H12.6667V12.6667H11.3333ZM11.3333 10V8.66667H12.6667V10H11.3333ZM12.6667 11.3333V10H14V11.3333H12.6667Z",
    fill: "#007985"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDigitalItemColored);
export default __webpack_public_path__ + "static/media/icon-digital-item-colored.452a1b19d06b6242592e399d388737b0.svg";
export { ForwardRef as ReactComponent };